import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ArrowUp } from "lucide-react"; // Import for Back to Top
import Header from "./Components/Header";
import Home from "./Pages/Home";
import Projects from "./Pages/Projects";
import Footer from "./Components/Footer";
import "./styles/theme.css";
import Contact from "./Pages/Contact";
import Services from "./Pages/Services";

function App() {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const [showScrollBtn, setShowScrollBtn] = useState(false);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  // Scroll to Top Logic
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    // Apply theme globally
    document.documentElement.setAttribute("data-theme", theme);

    // --- Global Custom Cursor Logic ---
    const cursor = document.createElement("div");
    cursor.className = "custom-cursor";
    const follower = document.createElement("div");
    follower.className = "cursor-follower";
    document.body.appendChild(cursor);
    document.body.appendChild(follower);

    const moveCursor = (e) => {
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
      // Smooth lag for follower
      setTimeout(() => {
        follower.style.left = `${e.clientX}px`;
        follower.style.top = `${e.clientY}px`;
      }, 50);
    };

    const handleMouseDown = () => (cursor.style.transform = "translate(-50%, -50%) scale(0.8)");
    const handleMouseUp = () => (cursor.style.transform = "translate(-50%, -50%) scale(1)");

    const handleMouseOver = (e) => {
      if (e.target.closest("a, button, .btn, .social-icon-link")) {
        cursor.classList.add("cursor-hover");
        follower.classList.add("follower-hover");
      }
    };

    const handleMouseOut = (e) => {
      if (e.target.closest("a, button, .btn, .social-icon-link")) {
        cursor.classList.remove("cursor-hover");
        follower.classList.remove("follower-hover");
      }
    };

    // --- Scroll Visibility Logic ---
    const handleScroll = () => {
      if (window.pageYOffset > 400) {
        setShowScrollBtn(true);
      } else {
        setShowScrollBtn(false);
      }
    };

    // Listeners
    window.addEventListener("mousemove", moveCursor);
    window.addEventListener("mousedown", handleMouseDown);
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mouseover", handleMouseOver);
    document.addEventListener("mouseout", handleMouseOut);

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      window.removeEventListener("mousedown", handleMouseDown);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mouseover", handleMouseOver);
      document.removeEventListener("mouseout", handleMouseOut);
      if (document.body.contains(cursor)) document.body.removeChild(cursor);
      if (document.body.contains(follower)) document.body.removeChild(follower);
    };
  }, [theme]);

  return (
    <Router>
      <div className="App">
        <Header theme={theme} toggleTheme={toggleTheme} />
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        <Footer />

        {/* Back to Top Button */}
        {showScrollBtn && (
          <button className="scroll-to-top-btn glass" onClick={scrollToTop}>
            <ArrowUp size={24} />
          </button>
        )}
      </div>
    </Router>
  );
}

export default App;